import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import { fmcValidator } from '../common';

export class AddressModel {
  addressForm = new UntypedFormGroup({
    'flatSearch': new UntypedFormControl(''),
    'addressId': new UntypedFormControl(''),
    'rPDataPropertyID': new UntypedFormControl(''),
    'rPDataRank': new UntypedFormControl(''),
    'isPoBox': new UntypedFormControl(false),
    'poBox': new UntypedFormControl(''),
    'unitNumber': new UntypedFormControl('', [], [fmcValidator('address')]),
    'streetNumber': new UntypedFormControl('', [], [fmcValidator('address')]),
    'propertyName': new UntypedFormControl('', [], [fmcValidator('address')]),
    'propertyType': new UntypedFormControl('', [], [fmcValidator('address')]),
    'propertyTypeSearch': new UntypedFormControl(''),
    'streetName': new UntypedFormControl('', [], [fmcValidator('address')]),
    'streetType': new UntypedFormControl('', [], [fmcValidator('address')]),
    'streetTypeSearch': new UntypedFormControl(''),
    'streetTypeSlug': new UntypedFormControl(''),
    'suburb': new UntypedFormControl('', [], [fmcValidator('address')]),
    'state': new UntypedFormControl(''),
    'stateSlug': new UntypedFormControl(''),
    'stateId': new UntypedFormControl(''),
    'postcode': new UntypedFormControl('', [], [fmcValidator('postcode')]),
    'country': new UntypedFormControl(13),
    'countrySlug': new UntypedFormControl(''),
    'fullAddress': new UntypedFormControl(''),
    'isManualEntry': new UntypedFormControl(false)
  });
}
